//if ( pplang == 'en') {
  var

  // Config = '// Config',
  locale = 'en',
  helpurl = 'https://ultrapassport.com/help/',
  _lwidth = '3em',


  // Globals = '// Globals',
  _globalnotice = `${regname} Ticket Registration Is Now Open! &nbsp;&nbsp;  <a href="${regurl}"><em>Register Here</em> <i class="fas fa-chevron-right"></i></a>`,
  _globalnotice2 = `${regname} Ticket Registration Is Now Open!`,
  _globalnoticereg = __( 'Check your email! We have sent you purchase instructions for tomorrow’s ticket sale.', 'ultra-2015' ),
  _maintenance = __( 'Ultra Passport is currently unavailable, please check back soon.', 'ultra-2015' ),

  // Guest = '// Guest',
  _guestnotice = __( 'You must be logged in to view this page.', 'ultra-2015' ),

  // Labels = '// Labels',
  _fullname = __( 'Full Name', 'ultra-2015' ),
  _firstname = __( 'First Name', 'ultra-2015' ),
  _lastname = __( 'Last Name', 'ultra-2015' ),
  _email = __( 'Email', 'ultra-2015' ),
  _emailaddy = __( 'Email Address', 'ultra-2015' ),
  _confirmemailaddy = __( 'Confirm Email Address', 'ultra-2015' ),
  _birthday = __( 'Birthday', 'ultra-2015' ),
  _location = __( 'Location', 'ultra-2015' ),
  _country = __( 'Country', 'ultra-2015' ),
  _homeevent = __( 'Home Event', 'ultra-2015' ),
  _gender = __( 'Gender', 'ultra-2015' ),
  _password = __( 'Password', 'ultra-2015' ),
  _male = __( 'Male', 'ultra-2015' ),
  _female = __( 'Female', 'ultra-2015' ),
  _pleaseselect = __( 'Please Select', 'ultra-2015' ),
  _signuptitle = __( 'Ultra Passport Enrollment', 'ultra-2015' ),
  _enteryouremail = __( 'Enter Your Email Address', 'ultra-2015' ),
  _backtologin = __( 'Back to Login', 'ultra-2015' ),
  _requestnewpass = __( 'Request New Password', 'ultra-2015' ),
  _on = __( 'On', 'ultra-2015' ),
  _off = __( 'Off', 'ultra-2015' ),
  _enrollmentavailable = __( 'Enrollment Now Available', 'ultra-2015' ),
  _goback = __( 'Go Back', 'ultra-2015' ),


  // Text Labels = '// Text Labels',
  _logintext = __( 'Login', 'ultra-2015' ),
  _password = __( 'Password', 'ultra-2015' ),
  _welcome = __( 'Welcome', 'ultra-2015' ),
  _account = __( 'Account', 'ultra-2015' ),
  _myaccount = __( 'My Account', 'ultra-2015' ),
  _mypassport = __( 'My Passport', 'ultra-2015' ),
  _events = __( 'Events', 'ultra-2015' ),
  _points = __( 'Points', 'ultra-2015' ),
  _updates = __( 'Updates', 'ultra-2015' ),
  _signout = __( 'Log Out', 'ultra-2015' ),
  _signin = __( 'Log In', 'ultra-2015' ),
  _signedin = __( 'Logged In', 'ultra-2015' ),
  _signuptext = __( 'Sign Up', 'ultra-2015' ),
  _nextlevel = __( 'Next Level', 'ultra-2015' ),
  _forgot = __( 'Forgot your password?', 'ultra-2015' ),
  _subscribed = __( 'Subscribed', 'ultra-2015' ),
  _subscribe = __( 'Subscribe', 'ultra-2015' ),
  _helpcenter = __( 'Help Center', 'ultra-2015' ),
  _error = __( 'Error', 'ultra-2015' ),
  _silver = __( 'Silver', 'ultra-2015' ),
  _gold = __( 'Gold', 'ultra-2015' ),
  _platinum = __( 'Platinum', 'ultra-2015' ),

  // Validation Messages = '// Validation Messages',
  _gendertext = __( 'You must choose a gender.', 'ultra-2015' ),
  _accepttext = __( 'You must accept the terms.', 'ultra-2015' ),


  // Email Verifications = '// Email Verifications',
  _resendverify = __( 'Resend Email Verification', 'ultra-2015' ),
  _revalidate = __( 'Please check your email to validate your new email address.', 'ultra-2015' ),
  _sendingverification = __( 'Sending Verification Email...', 'ultra-2015' ),
  _verifysent = __( 'Email Verification Sent', 'ultra-2015' ),
  _emailverifydashboard = __( 'Be sure to verify your email address for access to updates and ticket registrations.', 'ultra-2015' ),
  _emailverifyupdates = __( 'Be sure to verify your email to activate email updates.', 'ultra-2015' ),


  // Edit Page = '// Edit Page',
  _editaccount = __( 'Edit Account', 'ultra-2015' ),
  _nochanges = __( 'No Changes Detected', 'ultra-2015' ),
  _accountupdated = __( 'Account Updated', 'ultra-2015' ),
  _emailupdatedstarted = __( 'New email addresses must be verified, please check your email to confirm.', 'ultra-2015' ),
  _emailupdatedverified = __( 'Your new email address is now verified.', 'ultra-2015' ),
  _passwordresetsent = __( 'Password reset email sent.', 'ultra-2015' ),


  // Footer Signup = '// Footer Signup',
  _startinput = __( 'Enter your email address to get started...', 'ultra-2015' ),
  _starttext = __( 'Don’t have an account? Sign up to register <br class="small-hide">for events, earn points, and more!', 'ultra-2015' ),
  _getstarted = __( 'Get Started', 'ultra-2015' ),


  // Signup Page = '// Signup Page',
  _createaccount = __( 'Create My Account', 'ultra-2015' ),
  _almost = __( 'Almost Finished...', 'ultra-2015' ),
  _almost2 = 'Congratulations $user_firstname on creating your Ultra Passport<span class="tm">™</span> Account!',
  _almost3 = 'To activate your account, <strong><u>you MUST validate your email address</u></strong> by clicking the confirmation link we just sent to <strong>$user_email</strong>.',
  _almost4 = 'If you have not received any email <strong><u>please check your spam folder</u></strong> and add <strong><u>info@ultrapassport.com</u></strong> to your <strong><u>address book</u></strong>.',
  _almost5 = __( 'Continue', 'ultra-2015' ),
  _createdsuccess = __( 'Account created.', 'ultra-2015' ),
  _createdinfo = __( 'Account is being created:', 'ultra-2015' ),
  _accountactivated = __( 'Your account is now activated.', 'ultra-2015' ),
  _accountverified = __( 'Your email address has now been verified.', 'ultra-2015' ),
  _passwordresetsuccess = __( 'Password Reset Success', 'ultra-2015' ),


  // Updates = '// Updates',
  _updatestext1 = __( 'You must be logged in to subscribe for updates.', 'ultra-2015' ),
  _updatestextPending = __( 'Please verify your email address to receive updates.', 'ultra-2015' ),
  _updatessubsrcibe = __( 'You subscribed to receive updates for:', 'ultra-2015' ),
  _updatesunsubsrcibe = __( 'You unsubscribed to receive updates for:', 'ultra-2015' ),


  // Registration = '// Registration',
  _rbtnbuy = __( 'Buy Tickets Now', 'ultra-2015' ),
  _regbuy = __( 'Buy Tickets', 'ultra-2015' ),
  _rbtnregister = __( 'Register For Tickets', 'ultra-2015' ),
  _rbtnclosed = __( 'Registration Closed', 'ultra-2015' ),
  _rbtnsoon = __( 'Coming Soon', 'ultra-2015' ),
  _rbtnupdates = __( 'Get Updates', 'ultra-2015' ),
  _rbtnsoldout = __( 'Sold Out', 'ultra-2015' ),
  _rbtnwaitlist = __( 'Join Waitlist', 'ultra-2015' ),
  _verifyemailregister = __( 'You must verify your email address before registering.', 'ultra-2015' ),
  _registerbtn = __( 'Register', 'ultra-2015' ),
  _regbtnhtml = __( 'Registered', 'ultra-2015' ),
  _regerror = __( 'Error!', 'ultra-2015' ),
  _regerror2 = __( 'Please try again.', 'ultra-2015' ),
  _regprocessing = __( 'Your Registration is Processing...', 'ultra-2015' ),
  _registersuccess = __( 'Registration Successful', 'ultra-2015' ),
  _regaccepted = __( 'Your <u class="regtype"></u> registration was accepted on', 'ultra-2015' ),
  _regaccepted2 = __( 'Ticket purchase instructions will be sent to your email 24 hours prior to going on sale.', 'ultra-2015' ),
  _regaccepted2_2 = __( 'Ticket purchase instructions will be sent to your email 24-48 hours prior to going on sale.', 'ultra-2015' ),
  _regaccepted2_3 = __( "Ticket purchase instructions have been sent to your email.", 'ultra-2015' ),
  _regaccepted2_4 = __( "You will be the first to know when tickets are available. Stay tuned.", 'ultra-2015' ),
  _regaccepted3 = __( 'Ticket purchase instructions were sent to your email with your unique registration code.', 'ultra-2015' ),
  _regdone1 = __( 'Registration Code', 'ultra-2015' ),
  _regdone2 = __( 'You Registered on', 'ultra-2015' ),
  _regdone3 = __( 'Resend Purchase Instructions', 'ultra-2015' ),
  _selectregtype = __( 'Select Registration Type', 'ultra-2015' ),
  _regtype = __( 'Registration Type', 'ultra-2015' ),

  // Registrations Confirm = '// Registrations Confirm',
  _regtext1 = __( 'Is your information up-to-date?', 'ultra-2015' ),
  _regtext2 = __( 'Please confirm your registration information for', 'ultra-2015' ),
  _regguest1 = __( 'You must be logged in to register for events.', 'ultra-2015' ),
  _regpending1 = __( `You're almost there!`, 'ultra-2015' ),
  _regpending2 = __( 'Please verify your <strong>email address</strong> to unlock registration access.', 'ultra-2015' ),
  _updateinfobtn = __( 'Update My Information', 'ultra-2015' ),
  _confirmreg = __( 'Confirm my registration', 'ultra-2015' ),

  _waitlistguest1 = __( 'You must be logged in to join the waitlist', 'ultra-2015' ),
  _waitlistbtnjoin = __( 'Join Waitlist', 'ultra-2015' ),
  _waitlistbtnjoined = __( 'Waitlist Joined', 'ultra-2015' ),
  _waitlistdone = __( 'You Joined the Waitlist on', 'ultra-2015' ),
  _waitlistsuccess = __( `You're on the Waitlist!`, 'ultra-2015' ),
  _waitlistpending2 = __( 'Please verify your <strong>email address</strong> to unlock waitlist access.', 'ultra-2015' ),

  // Privacy / Terms Notice = '// Privacy / Terms Notice',
  privacytext = __( 'Privacy Policy', 'ultra-2015' ),
  termsofuse = __( 'Terms of Use', 'ultra-2015' ),

  // Copyright == '// Copyright ',
  upptextlogo = __( 'Ultra Passport<span class="tm">&trade;</span>', 'ultra-2015' ),
  privacylink = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${privacytext}</a>`,
  termslink = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${termsofuse}</a>`,
  _agreesignup = `I agree to the ${upptextlogo} ${privacylink} and ${termslink}.`,
  _agreesignup2 = `By signing up, you agree to the ${upptextlogo} ${privacylink} and ${termslink}.`,
  _agreeregister = `By <strong>registering</strong>, you agree to the ${upptextlogo} ${privacylink} and ${termslink}.`,
  _agreewaitlist = `By <strong>joining the waitlist</strong>, you agree to the ${upptextlogo} ${privacylink} and ${termslink}.`,

  // Passport Dashboard = '// Passport Dashboard',
  _action = __( 'Action', 'ultra-2015' ),
  _awarded = __( 'Awarded', 'ultra-2015' ),
  _award = __( 'Award', 'ultra-2015' ),
  _benefit = __( 'Benefit', 'ultra-2015' ),
  _howtoqualify = __( 'How to Earn', 'ultra-2015' ),
  _pointsexpire = __( '*Points Expire After 25 Calendar Months', 'ultra-2015' ),
  _qualifydisclaimer = __( '*Please note a "Full Ultra Festival" excludes: Road To Ultra, Ultra Beach and Resistance-only Events.', 'ultra-2015' ),
  _active = __( 'Active', 'ultra-2015' ),
  _deleted = __( 'Deleted', 'ultra-2015' ),
  _expired = __( 'Expired', 'ultra-2015' ),

  _btn_dashboard = __( 'Dashboard', 'ultra-2015' ),
  _btn_benefits = __( 'Benefits', 'ultra-2015' ),
  _btn_qualify = __( 'Earn', 'ultra-2015' ),
  _btn_points = __( 'My Points', 'ultra-2015' ),

  leveltext = _silver,
  nextlevel = _gold;

  var months = '';

  var _birthdayselect = '<label class="visuallyhidden" for="birthmonth">Birth Month</label><label class="visuallyhidden" for="birthyear">Birth Month</label><div class="datefield"><span class="subfield monthfield"><select class="required" id="birthmonth" name="birthmonth" style="width:80px;display:inline-block" autocomplete="bday-month"><option value="" disabled selected>MM</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option></select></span><span class="spacer">/</span> <span class="subfield dayfield"><select class="required" id="birthday" name="birthday" style="width:80px;display:inline-block" data-field="birthday" autocomplete="bday-day"><option value="" disabled selected>DD</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option><option value="30">30</option><option value="31">31</option></select></span><span class="spacer">/</span> <span class="subfield yearfield"><select class="required" id="birthyear" name="birthyear" style="width:100px;display:inline-block" autocomplete="bday-year"><option disabled selected>YYYY</option><option value="2017">2017</option><option value="2016">2016</option><option value="2015">2015</option><option value="2013">2013</option><option value="2012">2012</option><option value="2011">2011</option><option value="2010">2010</option><option value="2009">2009</option><option value="2008">2008</option><option value="2007">2007</option><option value="2006">2006</option><option value="2005">2005</option><option value="2004">2004</option><option value="2003">2003</option><option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option><option value="1936">1936</option><option value="1935">1935</option><option value="1934">1934</option><option value="1933">1933</option><option value="1932">1932</option><option value="1931">1931</option><option value="1930">1930</option><option value="1929">1929</option><option value="1928">1928</option><option value="1927">1927</option><option value="1926">1926</option><option value="1925">1925</option><option value="1924">1924</option><option value="1923">1923</option><option value="1922">1922</option><option value="1921">1921</option><option value="1920">1920</option><option value="1919">1919</option><option value="1918">1918</option><option value="1917">1917</option><option value="1916">1916</option><option value="1915">1915</option><option value="1914">1914</option><option value="1913">1913</option><option value="1912">1912</option><option value="1911">1911</option><option value="1910">1910</option><option value="1909">1909</option><option value="1908">1908</option><option value="1907">1907</option><option value="1906">1906</option><option value="1905">1905</option><option value="1904">1904</option><option value="1903">1903</option><option value="1902">1902</option><option value="1901">1901</option><option value="1900">1900</option></select></span></div>';


    // Benefits : '// Benefits',
    var _silverbenefits = [
    'Access to Register for Early Bird Tickets for Ultra events before the general public',
    ];
    var _goldbenefits = [
    'Access to Early Bird Tickets before Silver level buyers and the general public',
    'Use of a separate line for entry into festivals',
    'Access to the Ultra Passport Lounge',
    'Priority Customer Service'
    ];
    var _platinumbenefits = [
    'Access to Early Bird Tickets before Gold & Silver level Passport holders and the general public',
    'Subject to availability, access to special viewing platforms for select artist performances',
    'Special Benefits specific to each festival'
    ];


    // Errors : '// Errors',
    var errors = {
        reset : __( 'Invalid email or expired token, please make sure your cookies are enabled.', 'ultra-2015' ),
        create : __( 'Creation failed, please make sure your cookies are enabled.', 'ultra-2015' ),
        general : __( 'Oops! Something went wrong. Please make sure cookies are enabled.', 'ultra-2015' ),
        password : __( 'Password must be at least 8 characters.', 'ultra-2015' ),
        duplicateemail : __( 'Email account already in use.', 'ultra-2015' ),
        matchemail : __( `Your email addresses don't match. Please confirm and reenter your email address.`, 'ultra-2015' ),
        loginfail : __( 'The username and password you entered did not match our records. Please double-check and try again', 'ultra-2015' ),
        token : __( 'Invalid Token, Please Log in and try sending a new validation email.', 'ultra-2015' ),
        pnc : __( 'Please complete your profile to activate your account.', 'ultra-2015' ),
        birthday : __( 'You must be 16 years of age or older to enroll in Ultra Passport.', 'ultra-2015' ),
    }

    // Point Labels : '// Point Labels'
    var pointcodes = {
        manual : __( 'Passport Admin Adjustment', 'ultra-2015' ),
        unknown : __( 'Passport Admin Adjustment', 'ultra-2015' ),
        verify : __( 'Verified Account Email', 'ultra-2015' ),
        attend_festival : __( 'Attend a Full Ultra Festival', 'ultra-2015' ),
        attend_rtu : __( 'Attend a Road to Ultra Event', 'ultra-2015' ),
        attend_resistance : __( 'Attend a Resistance Only Event', 'ultra-2015' ),
        away_bonus : __( 'Attend Another Continent Event', 'ultra-2015' ),
        home_bonus_1 : __( 'Attend Your Home Event', 'ultra-2015' ),
        home_bonus_2 : __( 'Attend Your Home Event x 2', 'ultra-2015' ),
        home_bonus_3 : __( 'Attend Your Home Event x 3+', 'ultra-2015' ),
        home_bonus_4 : __( 'Attend Your Home Event x 3+', 'ultra-2015' ),
        home_bonus_5 : __( 'Attend Your Home Event x 3+', 'ultra-2015' ),
        home_bonus_6 : __( 'Attend Your Home Event x 3+', 'ultra-2015' ),
        home_bonus_7 : __( 'Attend Your Home Event x 3+', 'ultra-2015' ),
        home_bonus_8 : __( 'Attend Your Home Event x 3+', 'ultra-2015' ),
        home_bonus_9 : __( 'Attend Your Home Event x 3+', 'ultra-2015' ),
        activate_wristband : __( 'Activate Your Wristband', 'ultra-2015' ),
    };

    var pointcodes2 = {
        manual : __( 'Passport Admin Adjustment', 'ultra-2015' ),
        unknown : __( 'Passport Admin Adjustment', 'ultra-2015' ),
        verify : __( 'Verified Account Email', 'ultra-2015' ),
        attend_festival : __( 'Attend an Ultra Worldwide Festival', 'ultra-2015' ),
        attend_rtu : __( 'Attend a Road to Ultra Event', 'ultra-2015' ),
        attend_resistance : __( 'Attend a Resistance Only Event', 'ultra-2015' ),
        away_bonus : __( 'Traveler Bonus', 'ultra-2015' ),
        home_bonus_1 : __( 'Home Bonus', 'ultra-2015' ),
        home_bonus_2 : __( 'Loyalty Bonus', 'ultra-2015' ),
        home_bonus_3 : __( 'Expert Bonus', 'ultra-2015' ),
        activate_wristband : __( 'Activate Your Wristband', 'ultra-2015' ),
    };

    // Qualify : '// Qualify'
    var _qualify = {
        q1: [ 'Successfully confirm your Ultra Passport Enrollment', 1000 ],
        q2: [ 'Attend a Full Ultra Festival*', 30000 ],
        q3: [ 'Attend a Road To Ultra Event', 10000 ],
        q4: [ 'BONUS · Attend any event on a continent other than your home event', 20000 ],
        q5: [ 'BONUS · Attend your home event', 10000 ],
        q6: [ 'BONUS · Attend your home event for a second consecutive year', 20000 ],
        q7: [ 'BONUS · Attend your home event for a third consecutive year (and any consecutive year therereafter)', 30000 ],
    }

//}
